export enum ProductType {
    HYBRID = 'Hybrid, Structured Instruments',
    FIXEDINCOMEBOND = 'Fixed Income Bond',
    BONDS = 'Bonds',
    EQUITYFUNDS = 'Equity Funds',
    AMC = 'Actively Managed Certificates',
}